
import React, { useState, useEffect } from 'react';
import { DataGrid, GridToolbar, GridFilterPanel } from '@mui/x-data-grid';
import axios from 'axios';
import { Box, Button, Grid, TextField } from '@mui/material';

const GetAllBeaconDataRange = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const currentDate = new Date();
  const oneDayAfter = new Date(currentDate);
  oneDayAfter.setDate(currentDate.getDate() + 1);

  // Remove time components from initial date values
  let localStartDate = new Date(oneDayAfter.toDateString());
  let localEndDate = new Date(oneDayAfter.toDateString());

  const [dateRange, setDateRange] = useState({
    start: localStartDate,
    end: localEndDate,
  });

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(()=>{
    const handleResize = ()=> setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return ()=> window.removeEventListener("resize", handleResize);
  }, [isMobile]);

  // API call to fetch data based on the selected date range
  useEffect(() => {
    const fetchData = async (startDate, endDate) => {
      setLoading(true);

      try {
        const response = await axios.get(`${process.env.REACT_APP_URL}/api/v1/beacon/data/all`, {
          params: {
            startdate: startDate ? startDate.toISOString().split('T')[0] : '',
            enddate: endDate ? endDate.toISOString().split('T')[0] : '',
          },
        });

        setData(response.data.results || []);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData(dateRange.start, dateRange.end);
  }, [dateRange]);

  // Columns for MUI DataGrid
  const columns = [
    { field: 'id', headerName: 'ID', width: 90 },
    { field: 'ts', headerName: 'Timestamp (IST)', width: 180 },
    { field: 'device_id', headerName: 'Device ID', width: 150 },
    { field: 'mac', headerName: 'MAC Address', width: 180 },
    { field: 'asset_name', headerName: 'Asset Name', width: 150 },
    { field: 'rssi', headerName: 'RSSI', width: 120 },
    { field: 'battery', headerName: 'Battery', width: 120 },
  ];

  return (
    <Box p={3}>
      <Grid item xs={12} style={{ marginTop: 25 }}>
        <TextField
          label="Start Date"
          type="date"
          value={dateRange.start.toISOString().split('T')[0]}
          onChange={(e) => {
            let newStartDate = new Date(e.target.value);
            setDateRange({ ...dateRange, start: newStartDate });
          }}
          InputLabelProps={{
            shrink: true,
            style: {
              fontWeight: 700,
              color: "#005778",
              fontSize: 15,
            },
          }}
          InputProps={{
            style: {
              fontSize: 14,
              color: "rgba( 0, 0, 0, 70% )",
              height: 40,
            },
          }}
          style={{ width:isMobile ? "100%" : "40%", marginRight: 30, marginBottom: 30 }}
          sx={{
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "#50C1E9",
              },
              "&:hover fieldset": {
                borderColor: "#50C1E9",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#50C1E9",
              },
            },
          }}
        />
        <TextField
          label="End Date"
          type="date"
          value={dateRange.end.toISOString().split('T')[0]}
          onChange={(e) => {
            let newEndDate = new Date(e.target.value);
            setDateRange({ ...dateRange, end: newEndDate });
          }}
          InputLabelProps={{
            shrink: true,
            style: {
              fontWeight: 700,
              color: "#005778",
              fontSize: 15,
            },
          }}
          InputProps={{
            style: {
              fontSize: 14,
              color: "rgba( 0, 0, 0, 70% )",
              height: 40,
            },
          }}
          style={{ width:isMobile ? "100%" :  "40%", marginRight: 30 }}
          sx={{
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "#50C1E9",
              },
              "&:hover fieldset": {
                borderColor: "#50C1E9",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#50C1E9",
              },
            },
          }}
        />
      </Grid>

      <div style={{ height: 400, width: '100%', marginTop: '20px' }}>
        <DataGrid
          rows={data}
          columns={columns}
          pageSize={5}
          rowsPerPageOptions={[5, 10, 20]}
          loading={loading}
          getRowId={(row) => row.id}
          components={{
            Toolbar: GridToolbar,
            FilterPanel: GridFilterPanel,
          }}
          slotProps={{
            filterPanel: {
              sx: {
                width: "100%",          // full width responsive
                maxWidth: "100%",
                padding: "10px",
                "& .MuiDataGrid-filterForm": {
                  flexDirection: "column",
                  gap: "10px",
                },
              },
            },
          }}
        />
      </div>
    </Box>
  );
};

export default GetAllBeaconDataRange;
